import { useConfigStore } from "@/stores/config"

export const mixpanelProjectKeys = {
  production: "22b9d6e0493fe586ad81553ebc0ef1fb",
  test: "22eb0f7089b72267f1eda2edc7220493",
}

export const mixpanelProjectProxy = {
  production: "https://mixpanel-proxy.assessfirst.com",
  test: "https://mixpanel-proxy.assessfirst.info",
}

export const COOKIES = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  WORKFLOW_UUID: "af-workflow_uuid",
  PM_UUID: "af-pm_uuid",
  COMPANY_UUID: "af-company_uuid",
  RETAKE: "af-retake",
  AUTH_SESSION: "af-session-auth",
  BRANDING: "af-branding",
  SCREENING_AGENT_HR: "af-agent_hr",
  SCREENING_PM_NAME: "af-pm_name",
  SCREENING_COMPANY_NAME: "af-company_name",
  SCREENING_SHAREPOOL_LABEL: "af-sharepool_label",
  GOTO_NEXT: "af-goto_next",
  // lazy: the config store is only filled after `setConfig` in main.ts
  get OPTIONS() {
    return { path: "/", domain: useConfigStore().urls.cookie_domain }
  },
}
